<template>
  <div>
    <div class="flex mb-5">
      <div class="w-10/12">
        <h1 class="text-xl font-bold text-gray-700">Discounts</h1>
      </div>
      <div class="w-2/12">
        <base-button-primary @click="showModal = !showModal" class="float-right"
          >New Discount</base-button-primary
        >
      </div>
    </div>
    <el-table
      :data="discounts"
      :default-sort="{ prop: 'name', order: 'ascending' }"
      style="width: 100%"
    >
      <el-table-column prop="name" label="Name" sortable> </el-table-column>
      <el-table-column prop="type" label="Type" sortable> </el-table-column>
      <el-table-column label="Value" sortable>
        <template slot-scope="scope">
          <span v-if="scope.row.type === 'Dollar Value'"> $ </span>
          {{ getNumberFormatted(scope.row.value) }}
          <span v-if="scope.row.type === 'Percentage'"> % </span>
        </template>
      </el-table-column>
      <el-table-column label="">
        <template slot-scope="scope">
          <base-button-primary-extra-small @click="handleEdit(scope.row)">
            Edit
          </base-button-primary-extra-small>
          <base-button-white-extra-small
            @click="handleDelete(scope.row)"
            class="ml-3"
          >
            Delete
          </base-button-white-extra-small>
        </template>
      </el-table-column>
    </el-table>

    <base-modal :show="showModal" @close="showModal = false" @save="save">
      <template v-slot:header> Discount </template>
      <template v-slot:main>
        <div class="grid grid-cols-2 gap-4">
          <div class="col">
            <base-label>Name</base-label>
            <base-input v-model="discount.name" />
          </div>
          <div class="col">
            <base-label>Type</base-label>
            <el-select
              v-model="discount.type"
              placeholder="Select"
              class="w-full"
            >
              <el-option
                v-for="(type, index) in types"
                :key="index"
                :label="type"
                :value="type"
              >
              </el-option>
            </el-select>
          </div>
          <div v-if="discount.type === 'Dollar Value'" class="col">
            <base-label>Value</base-label>
            <base-currency
              :value="discount.value"
              @change="discount.value = $event"
            >
            </base-currency>
          </div>
          <div v-if="discount.type === 'Percentage'" class="col">
            <base-label>Value</base-label>
            <base-percent
              :value="discount.value"
              @change="discount.value = $event"
            >
            </base-percent>
          </div>
        </div>
      </template>
    </base-modal>
  </div>
</template>

<script>
import Validator from "../../components/common/Validator";
import currency from "../../mixins/currency";
export default {
  name: "Discounts",
  mixins: [currency],
  data() {
    return {
      showModal: false,
      discount: {
        id: null,
        name: "",
        value: 0,
        type: "",
      },
      types: ["Percentage", "Dollar Value"],
    };
  },
  methods: {
    handleEdit(row) {
      this.discount = {
        id: row.id,
        name: row.name,
        value: row.value,
        type: row.type,
      };
      this.showModal = true;
    },
    handleDelete(row) {
      if (confirm("Are you sure you want to delete this discount?")) {
        this.$store
          .dispatch("outfitter/delete_discount", row.id)
          .then((resp) => {
            if (!resp.success) return;

            this.$store.dispatch(
              "outfitter/reload_outfitter",
              this.$store.getters["auth/outfitterId"]
            );
            this.$notify({
              title: "Discount",
              message: "Discount has been deleted",
              type: "success",
            });
          });
      }
    },
    save() {
      if (
        !Validator([
          { field: this.discount.name, name: "Discount Name" },
          { field: this.discount.type, name: "Discount Type" },
          { field: this.discount.value, name: "Discount Value" },
        ])
      ) {
        return;
      }
      this.discount.outfitter_id = this.$store.getters["auth/outfitterId"];
      this.$store
        .dispatch("outfitter/save_discount", this.discount)
        .then((resp) => {
          if (!resp.success) return;

          this.$store.dispatch(
            "outfitter/reload_outfitter",
            this.$store.getters["auth/outfitterId"]
          );
          this.$notify({
            title: "Discount",
            message: "Data Saved",
            type: "success",
          });
          this.showModal = false;
          this.discount = {
            id: null,
            name: "",
            value: 0,
            type: "",
          };
        });
    },
  },
  computed: {
    discounts: function () {
      return this.$store.getters["outfitter/getDiscounts"];
    },
  },
  mounted() {},
};
</script>
